import { render } from "./BaseView.vue?vue&type=template&id=24f4840a"
import script from "./BaseView.vue?vue&type=script&lang=js"
export * from "./BaseView.vue?vue&type=script&lang=js"

import "./BaseView.vue?vue&type=style&index=0&id=24f4840a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__